import React from 'react';

import {ProfileTabSeparator} from 'src/components/profile-tab-structure';

import {StickyElement} from '@pb/kit-component-sticky-element';

import {
    BrowserRegistrationSection,
    ProductAccessSection,
    UserActivity,
    UserInformationSection,
    UserNotesSection,
} from './sections';
import {UserPageTabs} from './user-page-tabs';

import {
    userPageStructure,
    userPageStructureMain,
    userPageStructureSidebar,
} from './user-page-structure.module.styl';

type Props = {
    userId: number,
    activeTab: string,
    children: React.ReactNode,
    showSidebar?: boolean,
    canViewUserProducts?: boolean,
};

export const UserPageStructure = ({userId, children, showSidebar, activeTab, canViewUserProducts}: Props) => {
    return (
        <div className="enable-selection">
            <StickyElement findStickToElement={true}>
                <UserPageTabs {...{userId, activeTab}}/>
            </StickyElement>
            <div className={userPageStructure}>
                {showSidebar ? (
                    <div className={userPageStructureSidebar}>
                        <UserInformationSection userId={userId}/>
                        <ProfileTabSeparator/>
                        <UserActivity userId={userId}/>
                        <ProfileTabSeparator/>
                        {canViewUserProducts ? (
                            <>
                                <ProductAccessSection userId={userId}/>
                                <ProfileTabSeparator/>
                            </>
                        ) : null}
                        <BrowserRegistrationSection userId={userId}/>
                        <ProfileTabSeparator/>
                        <UserNotesSection userId={userId}/>
                    </div>
                ) : null}
                <div className={userPageStructureMain}>{children}</div>
            </div>
        </div>
    );
};
